module.exports = __webpack_public_path__ + "static/media/bonusScheme.531ccbb1.pdf";